import { defineEvent } from '../types/event';
export var PCP_PRODUCT_CARD_CLICK_TO_PDP = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'Clicks_on_PCP_ProductCard_to_PDP'
        }
    ]
});
